/* eslint arrow-body-style:0 */
import { every, filter } from 'lodash';

/**
 * @param {Array.<string>} doctorLocationIds
 * @param {Array.<moment>} dates
 * @param {timesgrid.AppointmentTimesStore} timesStore
 * @returns {Array.<moment>}
 */
export default function filterToDatesWithoutData(doctorLocationIds, dates, timesStore) {
    return filter(dates, date => {
        // If any doctor locations do not have times for the given date, return true
        return !every(doctorLocationIds, doctorLocationId => timesStore.hasTimesForDate(doctorLocationId, date));
    });
}
